var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M42,29 L42,12.6545455 L36.1782178,12.6545455 L40.5445545,0 L32.8514851,0 L24.8465347,14.0254545 L24.8465347,29 L42,29 Z M17.1534653,29 L17.1534653,12.6545455 L11.3316832,12.6545455 L15.8019802,0 L8.0049505,0 L0,14.0254545 L0,29 L17.1534653,29 Z"}));
}

Quote.defaultProps = {"viewBox":"0 0 42 29","version":"1.1"};

module.exports = Quote;

Quote.default = Quote;
